import styled from "styled-components";

export const Circle = styled.div.attrs({
  className: `
    flex
    items-center
    justify-center
    border-4
    border-orange-500
    rounded-full
    h-24
    w-24
    text-5xl
    zombie-font
  `,
})``;
